import { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";

const CountdownTimer = forwardRef(({ status, initialSeconds, onTime }, ref) => {
  const [time, setTime] = useState(initialSeconds);
  const [isActive, setIsActive] = useState(false);
  const intervalRef = useRef(null);

  

  const startTimer = () => {
    if (!isActive) {
      setIsActive(true);
      intervalRef.current = setInterval(() => {
        setTime((prev) => {
          if (prev > 0) {
            return prev - 1;
          } else {
            clearInterval(intervalRef.current);
            setIsActive(false);
            return 0;
          }
        });
      }, 1000);
    }
  };

  const pauseTimer = () => {
    if (isActive) {
      clearInterval(intervalRef.current);
      setIsActive(false);
    }
  };

  const stopTimer = () => {
    clearInterval(intervalRef.current);
    setIsActive(false);
    setTime(initialSeconds);
  };

  useImperativeHandle(ref, () => ({
    start: startTimer,
    pause: pauseTimer,
    stop: stopTimer,
    getCurrentSeconds: time,
  }));

  if (status === "start") {
    startTimer();
  }

  if (status === "pause") {
    pauseTimer();
  }

  if (status === "stop") {
    stopTimer();
  }

  useEffect(() => {
    if (time <= 0 && onTime) {
      onTime(); // Call the provided function when time runs out
    }
  }, [time, onTime]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? `0${secs}` : secs}`;
  };

  return <div>{formatTime(time)}</div>;
});

export default CountdownTimer;
